export default () => ({
  component: 'position-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
